(() => {
  if (customElements.get('ks-new-in-offer-banner')) return;
  customElements.define('ks-new-in-offer-banner', class extends HTMLElement {
    connectedCallback() {
      // Infinite loading appends each page's first banner. Keep a banner only
      // where the campaign group actually changes in the combined grid.
      queueMicrotask(() => {
        if (!this.isConnected) return;
        const row = this.closest('[data-ks-offer-banner]');
        const grid = row?.parentElement;
        if (!grid || grid.id !== 'product-grid') return;
        let previous = row.previousElementSibling;
        while (previous && !previous.hasAttribute('data-ks-offer-group')) {
          previous = previous.previousElementSibling;
        }
        if (previous?.dataset.ksOfferGroup === this.dataset.offerGroup) row.remove();
      });
    }
  });
})();
